import { createFeatureSelector, createSelector } from '@ngrx/store';

import { FeatureFlagsState } from './feature-flags.state';

export const selectFeatureFlagsState =
  createFeatureSelector<FeatureFlagsState>('featureFlags');

export const selectActiveFeatures = createSelector(
  selectFeatureFlagsState,
  (state) => state.activeFeatures
);

export const selectFeatureFlagsLoaded = createSelector(
  selectFeatureFlagsState,
  (state) => state.loaded
);

export const selectIsFeatureActive = (uid: string) =>
  createSelector(selectActiveFeatures, (features) => features.includes(uid));
